<template>
    <div class="checkbox-container">
      <img src="../../../assets/images/decoration/flowers.svg" alt="Flowers"/>
      <label>
        {{ label }}
        <input class="lily-input" type="checkbox" :checked="modelValue" @change="updateChecked">
      </label>
    </div>
  </template>

<script>
export default {
    name: 'DislikeLilyCheckBox',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'Dislike Lily?',
        },
    },
    methods: {
        updateChecked(event) {
            this.$emit('update:modelValue', event.target.checked);
        },
    },
};
</script>

  <style scoped>
  .checkbox-container {
    display: flex;
    align-items: center;
  }

  .checkbox-container input[type="checkbox"] {
    margin-right: 10px;
  }

  .checkbox-container img {
    margin-right: 10px;
  }

  .lily-input {
    margin-left: 10px;
    accent-color: black;
  }
  </style>
